// extracted by mini-css-extract-plugin
export default {"input":"Messages_input__nbCrQ","root":"Messages_root__brwyx"};